/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Group_YesterdayInputs */

const en_notifications_group_yesterday = /** @type {(inputs: Notifications_Group_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yesterday`)
};

const pl_notifications_group_yesterday = /** @type {(inputs: Notifications_Group_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wczoraj`)
};

/**
* | output |
* | --- |
* | "Yesterday" |
*
* @param {Notifications_Group_YesterdayInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const notifications_group_yesterday = /** @type {((inputs?: Notifications_Group_YesterdayInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Group_YesterdayInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_notifications_group_yesterday(inputs)
	return en_notifications_group_yesterday(inputs)
});